document.addEventListener('DOMContentLoaded', function() {
    function replaceScandinavianCharsFix(content) {
        return content
            .replace(/å/g, '&#xE94F;')
            .replace(/ä/g, '&#xE952;')
            .replace(/ö/g, '&#xE963;')
            .replace(/Å/g, '&#xE94F;')
            .replace(/Ä/g, '&#xE952;')
            .replace(/Ö/g, '&#xE963;');
    }

    function handleScandinavianCharsFix() {
        const elements = document.querySelectorAll('.quirky-spring-regular');
        elements.forEach(element => {
            element.innerHTML = replaceScandinavianCharsFix(element.innerHTML);
        });
    }

    handleScandinavianCharsFix();
});
